module.exports = __webpack_public_path__ + "img/prediction_list.e62b0929.png";